module.exports = "/images/frau-5.jpg?aa4a3201418ee433e3041828aadb447a";